export default "__VITE_ASSET__DvuZV9BQ__"